import { UserPrivileges } from 'types/usuario'
export const PrivilegesEnum: { [key in keyof UserPrivileges]: key } = {
  sn_portal: 'sn_portal',
  sn_simulacao: 'sn_simulacao',
  sn_gestao_vendas: 'sn_gestao_vendas',
  sn_material_apoio: 'sn_material_apoio',
  sn_material_apoio_inclui: 'sn_material_apoio_inclui',
  sn_material_apoio_exclui: 'sn_material_apoio_exclui',
  sn_material_apoio_altera: 'sn_material_apoio_altera',
  sn_material_apoio_relatorio: 'sn_material_apoio_relatorio',
  sn_documentacoes: 'sn_documentacoes',
  sn_documentacoes_inclui: 'sn_documentacoes_inclui',
  sn_documentacoes_exclui: 'sn_documentacoes_exclui',
  sn_documentacoes_altera: 'sn_documentacoes_altera',
  sn_documentacoes_relatorio: 'sn_documentacoes_relatorio',
  sn_flexibilizacao: 'sn_flexibilizacao',
  sn_flexibilizacao_nivel_1: 'sn_flexibilizacao_nivel_1',
  sn_flexibilizacao_nivel_2: 'sn_flexibilizacao_nivel_2',
  sn_flexibilizacao_nivel_3: 'sn_flexibilizacao_nivel_3',
  sn_gestao_publicidade: 'sn_gestao_publicidade',
  sn_confirmacao_contemplacao: 'sn_confirmacao_contemplacao',
  sn_permite_painel_analitico: 'sn_permite_painel_analitico',
  sn_permite_cancelar_cota: 'sn_permite_cancelar_cota',
  sn_emissao_carta: 'sn_emissao_carta',
  sn_utilizacao_carta_credito: 'sn_utilizacao_carta_credito',
  sn_utilizacao_carta_credito_permite_upload_comprovante: 'sn_utilizacao_carta_credito_permite_upload_comprovante',
  sn_utilizacao_carta_credito_permite_upload_dut: 'sn_utilizacao_carta_credito_permite_upload_dut',
  sn_utilizacao_carta_credito_permite_upload_nota_fiscal: 'sn_utilizacao_carta_credito_permite_upload_nota_fiscal',
  sn_permite_gestao_usuario: 'sn_permite_gestao_usuario',
  sn_cadastro_loja: 'sn_cadastro_loja',
  sn_aprovacao_loja: 'sn_aprovacao_loja',
  sn_bloquear_usuario: 'sn_bloquear_usuario',
  sn_desbloquear_usuario: 'sn_desbloquear_usuario'
}
